// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import Scroll from "react-scroll"; // Imports all Mixins
import { Grid, Row } from "react-bootstrap";
import {
  makeSelectData,
  makeSelectTransfers,
  makeSelectMoney,
  makeSelectOptions,
  makeSelectLoading,
  makeSelectError,
  makeSelectInfo
} from "../QuotePage/selectors";
import PersonalDetails from "./PersonalDetails/";
import YourDetails from "./YourDetails/";
import Terms from "./Terms/";
import Proceed from "./Proceed/"; 
import {
  changeBasketCurrency,
  updateNotification,
  proceedStep,
  confirmBooking
} from "../../actions/basket";
import './styles.css';

class ConfirmPage extends Component<void> {
  componentDidMount() {
    const scroll = Scroll.animateScroll;
    scroll.scrollToTop({ duration: 0 });
  }
  render() {
    const enquireText = this.props.basketData.enquireText;
    const pointsApplied = this.props.basketData.pointsApplied;
    if (!this.props.transfers) {
      return (
        <div className="text-center">
          <h1 style={{ color: "red" }}>Server Error</h1>
        </div>
      );
    }
    const inboundData = this.props.transfers[1]
      ? this.props.transfers[1]
      : null;
    return (
      <div>
        { this.props.loading ? (<div className="spinner"> <i className="fa fa-circle-o-notch fa-spin fa-5x fa-fw" /></div>) : null }
      <Grid className="confirm" fluid>

        <Row className="personal-details">
          <PersonalDetails
            inboundData={inboundData}
            outboundData={this.props.transfers[0]}
            id={this.props.basketData.id}
            options={this.props.options}
            money={this.props.money}
          />
        </Row>
       
        <Row className="your-details">
          <YourDetails
            inboundData={inboundData}
            outboundData={this.props.transfers[0]}
          />
        </Row>
        <Row className="terms">
          <Terms
            inboundData={inboundData}
            outboundData={this.props.transfers[0]}
            money={this.props.money}
            options={this.props.options}
            enquireText={enquireText}
            pointsApplied={pointsApplied}
            id={this.props.basketData.id}
            confirmBooking={this.props.confirmBooking}
            proceedStep={this.props.proceedStep}
            basketData={this.props.basketData}
            toPayPerPerson={this.props.basketData.toPayPerPerson}
            changeBasketCurrency={this.props.changeBasketCurrency}
          />
        </Row>
        <Row className="proceed">
          <Proceed
            money={this.props.money}
            updateNotification={this.props.updateNotification}
            id={this.props.basketData.id}
            customer={this.props.basketData.customer}
            promoCode={this.props.basketData.promoCode}
          />
        </Row>
      </Grid>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  basketData: makeSelectData(),
  transfers: makeSelectTransfers(),
  money: makeSelectMoney(),
  options: makeSelectOptions(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  help: makeSelectInfo()
});

export default connect(mapStateToProps, {
  changeBasketCurrency,
  updateNotification,
  proceedStep,
  confirmBooking
})(ConfirmPage);



// WEBPACK FOOTER //
// ./src/containers/ConfirmPage/index.js